import pubSub from '../utils/pubSub';
import { dom } from '../utils/dom';

import VanillaCalendar from './VanillaCalendar';
import popData from '../data/popData';

function weeks(w) {
  if (w == '1') {
    return w + ' Week &#x25BE;';
  } else {
    return w + ' Weeks  &#x25BE;';
  }
}
function setFieldValue(key, val) {
  let el = document.querySelector(`[name="${key}"]`);

  if (el != null) {
    el.value = val;
    // console.log(el, 'seeting value', el.value);
  }
}
window.setFieldValue = setFieldValue;

function addCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

let hasCents = false;
function money(val, pw) {
  let dollars = val.toFixed(2);
  let mon = addCommas(dollars).replace('.00', '');
  return '$' + mon + (pw ? '' : '');
}
function addWeeks(date, weeks) {
  let now = date;
  now.setDate(now.getDate() + weeks * 7);
  return now;
}

function fmtDate(date) {
  let m = date.getMonth() + 1;
  return m + '/' + date.getDate() + '/' + (date.getFullYear() + '').substr(2);
}

class FormsView {
  constructor() {
    popData(() => {
      this.popData = window.popData;
    });
    this.init();
  }

  doTheDate() {
    let { theMonth, theDay, theYear } = dom.els;

    let theDate = new Date();
    theDate.setMonth(parseFloat(theMonth.value) - 1);
    theDate.setDate(parseFloat(theDay.value));
    theDate.setYear(20 + '' + parseFloat(theYear.value));
    return theDate;
    // when blur any of these fields if all three are set
    // update vanillay calendar
  }
  init() {
    let {
      locationSelect,
      calBtn,
      theMonth,
      theDay,
      theYear,
      fullTimeBtn,
      partTimeBtn,
      theHourlyRate,
      closeCal,
      closeCalBig,
      emailReport,
      emailSub,
      emailClose
    } = dom.els;

    if (!window.isMobile.any) {
      [...document.querySelectorAll('[maxlength]')].forEach(el => {
        el.setAttribute('type', 'text');
      });
    }

    locationSelect.addEventListener('change', this.onStateChanged.bind(this));

    let calendar = new VanillaCalendar({
      selector: '#myCalendar',
      onSelect: (data, elem) => {
        let theDate = new Date(data.date);
        this.widgetDate = theDate;
      }
    });

    calBtn.addEventListener(dom.clickOrTouchEnd(), this.toggleCal);
    closeCal.addEventListener(
      dom.clickOrTouchEnd(),
      this.forceHideCal.bind(this)
    );
    closeCalBig.addEventListener(
      dom.clickOrTouchEnd(),
      this.forceHideCal.bind(this)
    );
    this.calToggle = false;

    theMonth.addEventListener('input', this.checkStartDate.bind(this));
    theDay.addEventListener('input', this.checkStartDate.bind(this));
    theYear.addEventListener('input', this.checkStartDate.bind(this));
    // theMonth.addEventListener('change', this.checkStartDate.bind(this));
    // theDay.addEventListener('change', this.checkStartDate.bind(this));
    // theYear.addEventListener('change', this.checkStartDate.bind(this));
    // expand.addEventListener(dom.clickOrTouchEnd(), this.onExpand.bind(this))
    // document.body.addEventListener('scroll', this.onScroll.bind(this));

    fullTimeBtn.addEventListener(
      dom.clickOrTouchEnd(),
      this.selectWorkType.bind(this)
    );
    partTimeBtn.addEventListener(
      dom.clickOrTouchEnd(),
      this.selectWorkType.bind(this)
    );
    // this.selectWorkType();

    theHourlyRate.addEventListener('input', this.checkHourlyRate.bind(this));
    theHourlyRate.addEventListener('focus', this.selectWorkType.bind(this));
    const infoIcons = [...document.querySelectorAll('.small-btn-icon')];
    infoIcons.forEach(info => {
      info.addEventListener(
        dom.downOrTouchStart(),
        this.onGetInfoStart.bind(this)
      );
      info.addEventListener(dom.clickOrTouchEnd(), this.onGetInfo.bind(this));
    });

    const benefitBtns = [
      ...document.querySelectorAll('.benefit-btn-container .smaller-btn')
    ];
    this.benefitBtns = benefitBtns;
    benefitBtns.forEach(btn => {
      // @TODO what to do for the other btns
      if (!btn.dataset.skip) {
        // @TODO dom.clickOrTouchEnd() @INVESTIGATE
        btn.addEventListener('click', this.onBenefitBtn.bind(this));
      } else {
        // @TODO pretty sure this is correct
        btn.addEventListener(dom.clickOrTouchEnd(), e => {
          //alert('show pop up');
        });
      }
    });

    this.benefitTypes = {};
    pubSub.on('model:calcsReady', this.onCalcsReady.bind(this));

    dom.els.closePopOver.addEventListener(dom.clickOrTouchEnd(), () => {
      dom.els.popOver.style.display = 'none';
    });

    pubSub.on('var:changed', this.onVarChanged.bind(this));

    this.beginValidation();

    const weekSelects = [...document.querySelectorAll('.rrt-weeks select')];

    weekSelects.forEach(select => {
      select.addEventListener('change', e => {
        if (e.target.dataset.el != null) {
          // console.log('get ready', e.target);

          dom.els[e.target.dataset.el.replace('Select', '')].value =
            e.target.selectedIndex + 1;
          pubSub.trigger('forms:performCalc');
        } else {
          alert('no such element');
        }
      });
    });

    const weekInputs = [
      ...document.querySelectorAll('.week-counter-input-container')
    ];
    weekInputs.forEach(el => {
      const less = el.querySelector('.week-less');
      const more = el.querySelector('.week-more');
      const inp = el.querySelector('.week-input input');
      less.addEventListener(dom.clickOrTouchEnd(), () => {
        let curr = parseFloat(inp.value) || 0;
        curr -= 1;
        if (curr > -1) {
          inp.value = curr;
        }
        less.classList.add('bigger-btn');
        setTimeout(() => less.classList.remove('bigger-btn'), 250);
      });

      more.addEventListener(dom.clickOrTouchEnd(), () => {
        let curr = parseFloat(inp.value) || 0;
        curr += 1;
        inp.value = curr;
        more.classList.add('bigger-btn');
        setTimeout(() => more.classList.remove('bigger-btn'), 250);
      });
    });

    this.weekCounters = [...document.querySelectorAll('.week-counter')];

    var pingId;
    var signup = $('#mc_embed_signup');
    var formHTML = signup.html();

    let form = $('#mc-embedded-subscribe-form');

    let emailMess = $('.email-mess');

    $('.submit-btn')[0].addEventListener(dom.clickOrTouchEnd(), () => {
      emailMess.text('');
    });
    // localhost... test;
    let updateURL =
      window.location.href.indexOf('localhost') != -1
        ? 'http://localhost:8888/matcalc/update-fields.php'
        : 'update-fields.php';

    let eventUrl =
      window.location.href.indexOf('localhost') != -1
        ? 'http://localhost:8888/matcalc/update-event.php'
        : 'update-event.php';
    clearInterval(pingId);
    pingId = setInterval(() => {
      let response = $('#mce-success-response');
      let errorResponse = $('#mce-error-response');

      var thankYou = response.text().indexOf('Thank') != -1;
      var isAlready =
        errorResponse.text().indexOf(' is already ') != -1 ||
        errorResponse.text().indexOf(' attempts ') != -1 ||
        errorResponse.text().indexOf(' too many ') != -1;

      if (
        (!isAlready && errorResponse.text().length > 0) ||
        $('.mce_inline_error').length > 0
      ) {
        // Sorry that is an invalid email
        emailMess.css('opacity', 1);
        emailMess.css('color', 'red');
        // console.log(errorResponse.text(), '<-- real error');
        emailMess.text('Sorry that is an invalid e-mail');
        errorResponse.text('');
        return;
      }

      if (thankYou) {
        emailMess.css('color', '');
        emailMess.css('opacity', 1);
        emailMess.text('Success!');
        response.text('');
        $('.submit-btn').fadeOut(150);
      }

      if (isAlready) {
        // console.log('boom shaka laka ', isAlready, thankYou);
        if (isAlready) {
          // console.log('zoom shaka laka');
          this.onCalcsReady(this.latestData);
          var formData = form.serializeArray();
          // console.log(formData);
          $.post(
            updateURL,
            {
              e: $('#mce-EMAIL').val(),
              d: formData
            },
            dat => {
              //////////////
              $.post(
                eventUrl,
                {
                  e: $('#mce-EMAIL').val()
                },
                () => {
                  // console.log('THANKS! -- ' + dat);
                  emailMess.css('opacity', 1);
                  emailMess.css('color', '');
                  emailMess.text('Success! Your info has been updated.');
                  $('.submit-btn').fadeOut(150);
                }
              );
              //////////////
            }
          );
        }

        errorResponse.text('');
      }
    }, 100);

    emailReport.addEventListener(dom.clickOrTouchEnd(), () => {
      //signup.html(formHTML);
      emailMess.html('');
      $('.submit-btn').fadeIn(0);
      emailSub.style.display = 'block';
    });

    emailClose.addEventListener(dom.clickOrTouchEnd(), () => {
      emailSub.style.display = 'none';
    });
  }

  evalBenefitforms() {
    let passed = true;
    let failedForms = 0;
    const payouts = [...document.querySelectorAll('.payout-input .cal-label')];
    payouts.forEach(el => {
      el.innerHTML = 'dollars/week';
      el.style.color = null;
    });
    const weekCounters = this.weekCounters;
    for (let i = 0; i < weekCounters.length; i++) {
      const el = weekCounters[i];
      // @TODO consider strange state issue maybe resetting these
      // when they are hidden and shown?
      if (el.style.display === 'block') {
        const inp = el.querySelector('.week-input input');
        const underline = el.querySelector('.cal-hr');
        const label = el.querySelector('.cal-label');
        const weekValue = parseFloat(inp.value);

        const payout = el.querySelector('.payout-input');
        if (payout) {
          const payoutInp = el.querySelector('.payout-input input');
          const payoutValue = parseFloat(payoutInp.value);
          const punderline = payout.querySelector('.cal-hr');
          const plabel = payout.querySelector('.cal-label');
          if (!payoutValue) {
            if (failedForms === 0) {
              this.badForm = el;
            }
            failedForms++;
            plabel.innerHTML = 'Enter a valid payout amount (dollars/week)';
            plabel.style.color = 'red';
            punderline.classList.add('failed-week-value');
            passed = false;
          } else {
            punderline.classList.remove('failed-week-value');
          }
        }
        if (!weekValue) {
          if (failedForms === 0) {
            this.badForm = el;
          }
          failedForms++;
          underline.classList.add('failed-week-value');
          label.innerHTML = 'Please enter a valid number of weeks';
          passed = false;
        } else {
          underline.classList.remove('failed-week-value');
          label.innerHTML = '';
        }
      }
    }
    if (!passed) {
      // @TODO scroll top?
    }
    return passed;
  }

  beginValidation() {
    if (window.location.hash != '#debug') {
      let { costNextBtn, anotherNextBtn } = dom.els;
      costNextBtn.style.visibility = 'hidden';
      anotherNextBtn.style.visibility = 'hidden';
    }
  }

  showHideCostNext(forceHide) {
    // console.log('tryinig to check it out', '??');
    let { costNextBtn } = dom.els;
    window.requestAnimationFrame(() => {
      let valid = false;
      let hasLoc = dom.els.locCheck.style.opacity != 0;
      let hasDate = dom.els.dateCheck.style.opacity != 0;
      // console.log(hasLoc, hasDate, '?', costNextBtn);
      if (hasLoc && hasDate && !forceHide) {
        //if (dom.els.costNextBtn.style.opacity != '1') {
        // TweenMax.from(dom.els.costNextBtn, 0.2, { opacity: 0 });
        costNextBtn.style.opacity = 1;
        costNextBtn.style.visibility = 'visible';
        //}
      } else {
        costNextBtn.style.visibility = 'hidden';
      }
    });
  }

  onCalcsReady(data) {
    this.latestData = data;
    // console.log('::', data);
    hasCents = false;
    let {
      totalWeeks,
      avgPerWeek,
      paidLeaveRow,
      paidLeaveWeeksCol,
      paidLeaveDollarsCol,
      disabilityRow,
      disabilityWeeksCol,
      disabilityDollarsCol,
      ptoRow,
      ptoWeeksCol,
      ptoDollarsCol,
      totalWeeksCol,
      totalDollarsCol,
      stateWeeksCol,
      stateDollarsCol,
      stateRow,
      usualPay,
      theDateCalcs,
      unpaidRow,
      unpaidWeeksCol
    } = dom.els;
    totalWeeks.innerHTML = data.details.totalWeeks + ' Weeks';

    setFieldValue('TOTALWEEKS', totalWeeks.innerHTML);

    avgPerWeek.innerHTML = money(data.details.avgPerWeek);

    setFieldValue('AVGINCOME', money(data.details.avgPerWeek));

    let sdate = this.doTheDate();
    let edate = addWeeks(sdate, data.details.totalWeeks);

    theDateCalcs.innerHTML = fmtDate(this.doTheDate()) + ' - ' + fmtDate(edate);
    setFieldValue('TIMEOFF', theDateCalcs.innerHTML);

    if (data.paidLeave.weeks !== 0) {
      paidLeaveRow.style.display = 'block';
      paidLeaveWeeksCol.innerHTML = weeks(data.paidLeave.weeks);
      paidLeaveDollarsCol.innerHTML = money(data.paidLeave.dollars, true);
      dom.els.paidLeaveWeeksSelect.selectedIndex = data.paidLeave.weeks - 1;
      setFieldValue('COMPWEEKS', paidLeaveWeeksCol.innerHTML);
      setFieldValue('COMPPAY', paidLeaveDollarsCol.innerHTML);
    } else {
      paidLeaveRow.style.display = 'none';
    }

    if (data.disability.weeks !== 0) {
      disabilityRow.style.display = 'block';
      disabilityWeeksCol.innerHTML = weeks(data.disability.weeks);
      disabilityDollarsCol.innerHTML = money(data.disability.dollars, true);
      dom.els.disabilityWeeksSelect.selectedIndex = data.disability.weeks - 1;
      setFieldValue('DISWEEKS', disabilityWeeksCol.innerHTML);
      setFieldValue('DISPAY', disabilityDollarsCol.innerHTML);
    } else {
      disabilityRow.style.display = 'none';
    }

    if (data.pto.weeks !== 0) {
      ptoRow.style.display = 'block';
      ptoWeeksCol.innerHTML = weeks(data.pto.weeks);
      ptoDollarsCol.innerHTML = money(data.pto.dollars, true);
      dom.els.ptoWeeksSelect.selectedIndex = data.pto.weeks - 1;

      setFieldValue('PTOWEEKS', ptoWeeksCol.innerHTML);
      setFieldValue('PTOPAY', ptoDollarsCol.innerHTML);
    } else {
      ptoRow.style.display = 'none';
    }

    if (data.unpaid.weeks !== 0) {
      unpaidRow.style.display = 'block';
      unpaidWeeksCol.innerHTML = weeks(data.unpaid.weeks);
      dom.els.unpaidWeeksSelect.selectedIndex = data.unpaid.weeks - 1;
      // unpai.innerHTML = money(data.pto.dollars, true);

      setFieldValue('UNPWEEKS', unpaidWeeksCol.innerHTML);
      //setFieldValue('PTOPAY', ptoDollarsCol.innerHTML);
    } else {
      unpaidRow.style.display = 'none';
    }

    if (data.state.weeks !== 0) {
      stateRow.style.display = 'block';
      stateWeeksCol.innerHTML = weeks(data.state.weeks);
      stateDollarsCol.innerHTML = money(data.state.dollars, true);
      dom.els.stateWeeksSelect.selectedIndex = data.state.weeks - 1;
      setFieldValue('STATEWEEKS', stateWeeksCol.innerHTML);
      setFieldValue('STATEPAY', stateDollarsCol.innerHTML);
    } else {
      stateRow.style.display = 'none';
    }

    if (totalWeeks != 0) {
      usualPay.innerHTML = money(data.details.usualPay);
      usualPay.style.display = 'inline-block';
      setFieldValue('USUALPAY', usualPay.innerHTML);
    } else {
      usualPay.style.display = 'none';
    }

    totalWeeksCol.innerHTML = totalWeeks.innerHTML;
    totalDollarsCol.innerHTML = money(data.details.totalDollars, true);
    setFieldValue('TOTALPAY', totalDollarsCol.innerHTML);

    /*
    {paidLeave: {…}, disability: {…}, pto: {…}, details: {…}}
    paidLeave: {dollars: 960, weeks: 4}
    disability: {dollars: 0, weeks: 0}
    pto: {dollars: 0, weeks: 0}
    details: {totalWeeks: 4, totalDollars: 960, avgPerWeek: 240}
    */
  }

  reset() {
    // set all input fields to empty @TODOO
  }
  calculateBenefitForm(el) {
    dom.els.benefitBlocks.style.display = 'none';
    const form = dom.els[el.dataset.form];

    if (form) {
      if (el.classList.contains('toggled')) {
        form.style.display = 'block';
      } else {
        form.style.display = 'none';
      }
    } else {
      // console.log('no form', el.dataset.form);
    }

    // FormsView.js:83 no form weekDisabilityForm
    // dom.els.benefitBlocks.opacity = 0;
    for (let i = 0; i < this.benefitBtns.length; i++) {
      let btn = this.benefitBtns[i];
      if (btn.classList.contains('toggled')) {
        dom.els.benefitBlocks.style.display = 'block';
        dom.els.benefitBlocks.style.opacity = 1;
      }
    }
  }

  onBenefitBtn(e) {
    const curr = e.currentTarget;
    // if (e.target.classList.contains(''))

    if (
      e.target.tagName === 'IMG' ||
      e.target.classList.contains('small-btn-icon')
    ) {
      return;
    }

    if (curr.classList.contains('toggled')) {
      curr.classList.remove('toggled');
    } else {
      curr.classList.add('toggled');
    }

    this.calculateBenefitForm(e.currentTarget);

    pubSub.trigger('form:adjustHeight');
  }

  onGetInfoStart(e) {
    const curr = e.currentTarget;
    curr.classList.add('info-tapped');
  }

  onGetInfo(e) {
    // let data = {
    //   'maternity-info': ['Paid Leave Info', 'Some information here...'],
    //   'disability-info': [
    //     'Short Term Disability Info',
    //     'Some information here...'
    //   ],
    //   'pto-info': ['PTO Info', 'Some information here...'],
    //   'fmla-info': ['fmla Info', 'Some information here...'],
    //   'state-centric-info': ['fmla Info', 'Some information here...']
    // };
    const curr = e.currentTarget;

    const key = curr.parentNode.querySelector('div').innerText.trim();
    const data = this.popData[key];
    // console.log(data);
    curr.classList.remove('info-tapped');
    // console.log(e.currentTarget);
    this.alert(key, data);
  }

  alert(title, message) {
    let { popOver, popOverTitle, popOverContent } = dom.els;

    popOverTitle.innerHTML = title;
    popOverContent.innerHTML = message;
    popOver.style.display = 'block';
  }

  onVarChanged(e) {
    if (!this.currentState) return;
    if (e.name === 'hoursPerWeek') {
      // if (e.val < this.currentState[2]) {
      //   dom.els.stateCentric.style.display = 'none';
      // } else {
      dom.els.stateCentric.style.display = 'inline-block';
      //}
    }
  }

  onStateChanged(e) {
    const value = e.target.options[e.target.selectedIndex].text;
    dom.els.currState.innerHTML = value;
    let stateCentric = false;

    // @TODO remove minimum
    let states = window.statecentric;
    this.currentState = null;
    let abbr;
    for (let i = 0; i < states.length; i++) {
      if (value === states[i][0]) {
        abbr = states[i][1];
        this.currentState = states[i];
        stateCentric = true;
        break;
      }
    }
    if (stateCentric) {
      dom.els.stateCentric.style.display = 'inline-block';
      dom.els.stateCentric.querySelector('div').innerHTML = `${abbr}`;
    } else {
      dom.els.stateCentric.style.display = 'none';
      dom.els.weekStateForm.style.display = 'none';
    }

    /*
    California // XXX:
Connecticut x
D.C. (I know, it's not a state) — starts in July 2020
Massachusetts
New Jersey
New York
Oregon — workers won't start receiving benefits until 2023
Rhode Island
Washington
*/

    // }
    //
    // stateChanged() {
    TweenMax.to(dom.els.locArrow, 0.3, {
      opacity: 0
    });
    TweenMax.to(dom.els.locCheck, 0.3, {
      opacity: 1,
      delay: 0.2
    });
    TweenMax.to(dom.els.pinLocation, 0.3, {
      opacity: 0
    });
    TweenMax.to(dom.els.yourLoc, 0.3, {
      y: -121
    });

    TweenMax.to(dom.els.whenStart, 0.3, {
      opacity: 1,
      delay: 0.3
    });

    dom.els.bigDate.style.opacity = 0;
    dom.els.bigDate.style.display = 'block';
    TweenMax.to(dom.els.bigDate, 0.4, {
      opacity: 1,
      delay: 0.3
    });
  }

  checkStartDate() {
    const { theMonth, theDay, theYear } = dom.els;

    const selectedDate = this.doTheDate();
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    let isPast = false;
    if (selectedDate < now) {
      // if (theYear.value.length > 1) {
      isPast = true;
      // }
      // console.log('Selected date is in the past');
    } else {
      // console.log('Selected date is NOT in the past');
    }

    if (
      theMonth.value.length > 0 &&
      theDay.value.length > 0 &&
      theYear.value.length > 1 &&
      !isPast
    ) {
      dom.els.dateWarn.innerHTML = '';
      TweenMax.to(dom.els.dateCheck, 0.3, {
        opacity: 1
      });
      this.showHideCostNext();
    } else {
      TweenMax.to(dom.els.dateCheck, 0.3, {
        opacity: 0,
        noComplete: () => {
          if (isPast) {
            dom.els.dateWarn.innerHTML = 'Pick a valid date in the future';
          }
        }
      });

      this.showHideCostNext(true);
    }
  }

  checkHourlyRate(e) {
    let val = parseFloat(e.target.value.trim());
    dom.els.hourlyWarn.style.display = 'none';
    if (val === 0) {
      TweenMax.to(dom.els.hourlyRateCheck, 0.1, { opacity: 0 });
      //alert('Please enter an hourly rate greater than zero.');
      dom.els.hourlyWarn.style.display = 'block';
      TweenMax.to(dom.els.hourlyRateCheck, 0.1, { opacity: 0 });
      TweenMax.to(dom.els.anotherNextBtn, 0.2, {
        opacity: 0,
        onComplete: () => {
          dom.els.anotherNextBtn.style.visibility = 'hidden';
        }
      });
    } else if (!isNaN(val)) {
      TweenMax.to(dom.els.hourlyRateCheck, 0.3, { opacity: 1 });
      if (parseFloat(dom.els.anotherNextBtn.style.opacity) > 0) {
        dom.els.anotherNextBtn.style.opacity = 1;
      } else {
        dom.els.anotherNextBtn.style.opacity = 0;
        TweenMax.to(dom.els.anotherNextBtn, 0.2, { opacity: 1 });
      }
      dom.els.anotherNextBtn.style.visibility = 'visible';
    } else {
      //alert('Please enter a valid hourly rate.');
      dom.els.hourlyWarn.style.display = 'block';
      TweenMax.to(dom.els.hourlyRateCheck, 0.1, { opacity: 0 });
      TweenMax.to(dom.els.anotherNextBtn, 0.2, {
        opacity: 0,
        onComplete: () => {
          dom.els.anotherNextBtn.style.visibility = 'hidden';
        }
      });
    }
  }

  selectWorkType(e) {
    TweenMax.to(dom.els.caseIcon, 0.3, {
      opacity: 0
    });

    TweenMax.to(dom.els.yourWork, 0.3, {
      y: -120,
      delay: 0.1
    });
    this.hasBeenSelected = true;
    // dom.els.fullTimeBtn.classList.remove('toggled');
    // dom.els.partTimeBtn.classList.remove('toggled');
    // if (e.currentTarget.classList.contains('parttime')) {
    //   e.currentTarget.classList.add('toggled');
    // } else {
    //   e.currentTarget.classList.add('toggled');
    // }
    // TweenMax.to(dom.els.caseIcon, 0.3, {
    //   opacity: 0
    // });
    // TweenMax.to(dom.els.workTimeCheck, 0.3, {
    //   opacity: 1,
    //   delay: 0.1
    // });
    // TweenMax.to(dom.els.yourWork, 0.3, {
    //   y: -120,
    //   delay: 0.1
    // });
    // dom.els.hourlyRate.style.opacity = 0;
    // dom.els.hourlyRate.style.display = 'block';
    // TweenMax.to(dom.els.hourlyRate, 0.3, {
    //   opacity: 1,
    //   delay: 0.2
    // });
    //
    // dom.els.hoursContainer.style.opacity = 0;
    // dom.els.hoursContainer.style.visibility = 'shown';
    // TweenMax.to(dom.els.hoursContainer, 0.3, {
    //   opacity: 1,
    //   delay: 0.3
    // });
  }

  forceHideCal() {
    if (this.widgetDate) {
      const theDate = this.widgetDate;
      dom.els.theMonth.value = theDate.getMonth() + 1;
      dom.els.theDay.value = theDate.getDate();
      dom.els.theYear.value = (theDate.getFullYear() + '').slice(2);
      window.requestAnimationFrame(() => {
        this.checkStartDate();
        this.showHideCostNext();
      });
    }

    // this.calToggle = true;
    // dom.els.fullCal.style.display = 'none';
    this.toggleCal();
  }

  toggleCal() {
    if (dom.els.fullCal.style.display != 'block') {
      dom.els.fullCal.style.display = 'block';
    } else {
      dom.els.fullCal.style.display = 'none';
    }
    this.calToggle = !this.calToggle;
  }

  initEvents() {}
}

export default FormsView;
